import './creeping-line.scss';

type CTAButtonPropsType = {};

const CreepingLine = ({ text }: CTAButtonPropsType) => {
  return <div className="creeping-line">{text}</div>;
};

export default CreepingLine;
